import { Box } from '@mui/material';

export default function CatalogBadge({ isCatalog }) {
	return (
		<Box
			sx={{
				color: 'white',
				backgroundColor: isCatalog ? '#5582F6' : '#737373',
				borderRadius: '0 0 8px 0',
				width: 'fit-content',
				padding: '4px',
			}}
		>
			{isCatalog ? 'Catalogo' : 'Sin Catalogo'}
		</Box>
	);
}
